import * as React from 'react';
import { ILinks2Data } from '../absolute-ff.props.autogenerated';

export interface IContentCardLinks2 {
    links2: ILinks2Data[];
}

const ContentCardLinks2: React.FC<IContentCardLinks2> = ({ links2 }) => (
    <div className='ms-content-block__cta'>
        {links2.map((cta: ILinks2Data, index: number) => {
            const btnClass = index === 0 ? 'msc-cta__primary' : 'msc-cta__secondary';
            return <a
                key={`link-${index}`}
                className={btnClass}
                role='button'
                title={cta.linkText}
                href={cta.linkUrl && cta.linkUrl.destinationUrl}
                aria-label={cta.ariaLabel}
                target={cta.openInNewTab ? '_blank' : undefined}
            >
                {cta.linkText}
            </a>;
        })}
    </div>
);

export default ContentCardLinks2;